











































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import Moment from 'moment';

import { DailyChallenge } from 'frontend/types/daily-challenges';

@Component({
  computed: {
    ...mapState('dcCalendar', ['calendar']),
    ...mapState('dailyChallenges', ['dc']),
  },
})
export default class DailyChallengeCalendar extends Vue {
  private dc?: DailyChallenge;

  private get today(): string {
    return Moment().format('DD, MMMM YYYY');
  }

  private isToday(day: string, monthYearStr: string): boolean {
    return `${day}, ${monthYearStr}` === this.today;
  }

  private isCurrent(slug: string): boolean {
    return this.dc?.slug === slug;
  }

  private get isDailyProblemDetail(): boolean {
    return this.$route.name === 'daily_problems_problem';
  }
}
